export class Timer {
    private callback: Function;
    private delay: number;

    private interval: number = 0;

    public constructor(callback: Function, delay: number) {
        this.callback = callback;
        this.delay = delay;
    }

    public stop() {
        clearInterval(this.interval);
    }

    public start() {
        this.interval = setInterval(this.callback, this.delay);
    }

    public reset(newDelay: number = this.delay) {
        this.delay = newDelay;
        this.stop();
        this.start();
    }
}
